export const CONSTANTS = {
  latitude: "core_hasLatitude",
  longitude: "core_hasLongitude",
  address: "6cb44afb-56e5-4b8b-9b1c-4df8c155d545_hasAddress",
  mainName: "6cb44afb-56e5-4b8b-9b1c-4df8c155d545_hasName",

  name: "core_hasListName",
  order: "core_hasOrder",
  parent: "core_hasParentValue"
}
